// This module provides API call methods for Sephora Commerce Utility APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Utility+APIs

const storeLocator = require('./storeLocator');
const getAboutMeReviewQuestions = require('./getAboutMeReviewQuestions');
const getAdvocacyLandingPageContent = require('./getAdvocacyLandingPageContent');
const enrollCampaign = require('./enrollCampaign');
const updatePreviewSettings = require('./updatePreviewSettings');
const getPreviewSettings = require('./getPreviewSettings');
const getCountryList = require('./getCountryList');
const getShippingCountryList = require('./getShippingCountryList');
const getSubscriptionCancelReasons = require('./getSubscriptionCancelReasons');
const getGiftCardBalance = require('./getGiftCardBalance');
const getStateAndCityForZipCode = require('./getStateAndCityForZipCode');
const getStateList = require('./getStateList');
const getLocation = require('./getLocation');
const contactUs = require('./contactUs/contactUs');
const resetSessionExpiry = require('./resetSessionExpiry');
const validateAddress = require('./validateAddress');
const isUserEligible = require('./isUserEligible');

const {
    requestEmailNotificationForOutOfStockSku,
    requestEmailNotificationForComingSoonSku,
    cancelEmailNotificationRequest
} = require('./requestEmailNotification');

module.exports = {
    storeLocator,
    getAboutMeReviewQuestions,
    enrollCampaign,
    getAdvocacyLandingPageContent,
    updatePreviewSettings,
    getPreviewSettings,
    getCountryList,
    getShippingCountryList,
    getSubscriptionCancelReasons,
    getGiftCardBalance,
    getStateAndCityForZipCode,
    getStateList,
    requestEmailNotificationForOutOfStockSku,
    requestEmailNotificationForComingSoonSku,
    cancelEmailNotificationRequest,
    getLocation,
    contactUs,
    resetSessionExpiry,
    validateAddress,
    isUserEligible
};
